import React from 'react'
import Header from '../components/Common/Header/Header'
import Main from '../components/LandingPage/MainContainer/Main'

const HomePage = () => {
  return (
    <div>
       <Header/>
       <Main/>
    </div>
  )
}

export default HomePage
